<template>
    <div class="DemandPlanning">
        <navbarv2 />
		<header class="header">
			<img src="../../assets/images/products/demand-plan-bg.jpg" class="desktop-img">
			<section class="banner-img-text">
                <h1 class="banner-title">Demand Planning</h1>
                <div class="sub-text">
                    NymbleUp provides ability to have predictive
                    visibility for optimum level of stock at store.
                    Our AI based solution uses multiple
                    parameters such as historical sales data,
                    growth trends, annual, weekly daily
                    seasonality coupled with external impulses
                    such as weather, promotions and holidays to
                    deliver highly accurate sales forecast at an
                    individual store level.
                </div>
			</section>
		</header>

        <div class="mb-8">
            <div class="section-title">
                What you can do with Demand Planning
            </div>

            <div class="product-details-section">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/dynamic-service.png">
                            </div>
                            <div>
                                <h4 class="product-title">Dynamic Service Levels</h4>
                                <div class="product-details">
                                    Our tool constantly studies sales pattern at an
                                    individual level and basis usage of an
                                    SKU/ingredient and dynamically suggests the
                                    most optimum Service Level to determine
                                    safety stock.
                                    This helps strike the right balance between
                                    Stock Out and Wastage thereby ensuring
                                    optimum customer experience at all times
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/stock.png">
                            </div>
                            <div>
                                <h4 class="product-title">Stock Count</h4>
                                <div class="product-details">
                                    ‘Single Click Stock Count’: Our Solution
                                    provides a user-friendly mechanism for
                                    taking stock with minimum effort. ‘Stock
                                    Calendar’ feature allows users to set calendar
                                    for all categories of items and notifies users
                                    on the day of Stock Count
                                    Tool also has provision to record any
                                    damaged products, customer return
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 40px;" :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/calendar.png">
                            </div>
                            <div>
                                <h4 class="product-title">Batch and Expiry Management</h4>
                                <div class="product-details">
                                    NymbleUp keeps track of batch wise expiry of
                                    SKUs and follows FEFO (First Expiry First
                                    Out) principle. Retailers can set category-wise
                                    triggers for alerts if any item is about to
                                    expire.
                                    Our notification engine alerts users of any
                                    impending expiry and allows users to make
                                    timely interventions to ensure store level
                                    write-offs are reduced
                                </div>
                            </div>
                        </div>
                    </el-col>

                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/recipes.png">
                            </div>
                            <div>
                                <h4 class="product-title">Recipe Management</h4>
                                <div class="product-details">
                                    Platform provides an easy to use recipe
                                    management that allows supply chain and
                                    operations team to track, edit and create new
                                    items Tool helps in controlling wastage and ensure
                                    recipe adherence at all stores.
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 40px;" :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/liquidity.png">
                            </div>
                            <div>
                                <h4 class="product-title">Expiry Liquidation</h4>
                                <div class="product-details">
                                    We are in the process of developing a tool,
                                    which will allow retailers to liquidate any
                                    upcoming near expiry SKUs to be liquidated.
                                    Retailers can use this tool to give instant
                                    discounts to customers to sell near expiry
                                    items.
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <requestDemo></requestDemo>
        <footerbar />
    </div>
</template>
<script>
import RequestDemoBar from '../../components/requestDemoBar/RequestDemoBar.vue';

export default {
    name: 'DemandPlanning',
    components: {
        'requestDemo': RequestDemoBar
    },
    metaInfo() {
        return {
            title: 'Demand Planning Platform',
            titleTemplate: '%s - NymbleUp',
            htmlAttrs: {
              lang: 'en',
              amp: true
            },
            meta: [
              {
                vmid: 'title',
                name: 'title',
                content: 'Demand Planning Platform - NymbleUp'
              },
              {
                vmid: 'description',
                name: 'description',
                content: 'NymbleUp provides the ability to have predictive visibility for the optimum level of stock at the store. We deliver highly accurate sales forecasts at an individual store level.'
              }
            ]
        }
    },
}
</script>
<style lang="scss" scoped>
.DemandPlanning {
    .header {
        position: relative;
        width: 100%;
        // background: #E29D5A;
        // background: linear-gradient(#fee7ac 0%, #E29D5A 95.02%, #E29D5A 100%, #fee7ac 100%, #E29D5A 100%);
        // background: linear-gradient(#5a66fa 0%, #212975 95.02%, #1e266e 100%, #1d266c 100%, #1e266e 100%);
        // background-image: url('../../assets/images/homepage/banner.jpg');
        // background-repeat: no-repeat;
        // background-size: cover;
        // background: black;
        background: black;
        text-align: center;
        height: 85vh!important;
        overflow: hidden;
        .desktop-img {
            margin-top: 60px;
            object-fit: cover;
            opacity: 0.2;
            height: 100%;
            width: 100%;
        }
        .banner-img-text{
            height: 100%;
            position: absolute;
            top: 40%;
            left: 0;
            right: 0;
            padding: 0 10px;
            .banner-title{
                color: #fff;
                line-height: 1.5;
            }
            .sub-text{
                font-size: 1rem;
                color: #fff;
                max-width: 800px;
                margin: 10px auto;
                line-height: 1.5;
            }
        }
    }

    .section-title{
        font-size: 22px;
        font-weight: 500;
        text-align: center;
        margin: 40px 0 60px 0;
        position: relative;
    }

    .section-title::after{
        position: absolute;
        bottom: -28px;
        left: 50%;
        width: 40px;
        height: 1px;
        margin-bottom: 15px;
        content: "";
        transform: translateX(-50%);
        background-color: #E29D5A;
    }

    .product-details-section{
        padding: 0 100px;
        .product-details-col{
            margin: 20px 0;
            display: flex;
            justify-content: center;
            .product-icon{
                width: 60px;
                height: 60px;
                min-width: 60px;
                // #d2d4e1
                background: rgba(253,207,90,0.5);
                display: -webkit-flex;
                display: -webkit-box;
                display: -moz-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin-right: 20px;
                img{
                    max-width: 35px;
                }
            }
            .product-title{
                font-size: 15px;
                color: #E29D5A;
            }
            .product-details{
                margin-top: 12px;
                font-size: 0.9rem;
                color: #000;
                line-height: 1.5;
                max-width: 400px;
            }
        }
    }
    @media screen and (max-width: 992px) {
        .product-details-section{
            padding: 0 10px;
        }
    }
}
</style>
